











































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import {
    BranchCard,
    CardCase,
    CardCases,
    CardIndex,
    BaseCard,
    isParamCard,
    isScorecardCard
} from '@/entities/conversation'
import {
    blankCard, firstCase
} from '@/transforms/conversation'
import {
    ContextualData
} from '../ConversationValidator'
import Tabs from '@/components/Tabs.vue'
import Tab from '@/components/Tab.vue'
import DropMenu from './DropMenu.vue'
import {
    Dict
} from '@/entities'

/*
Wrapper for BaseCards that adds branching management
*/

@Component<BranchedView>({
    components: {
        Tabs,
        Tab,
        DropMenu
    }
})
export default class BranchedView extends Vue {

    @Prop(Object) public card!: BranchCard
    @Prop(Object) public cardIndex!: CardIndex

    @Getter public getContextual!: Dict<ContextualData>

    @Action public loadCustomFieldOptions!: (field: string) => void

    public activeTab = ''

    public mounted() {
        this.loadCustomFieldOptions(this.match)
        const first = firstCase(this.card)
        if (first) {
            this.activeTab = String(first.key)
        }
    }

    @Watch('match')
    public watchMatch() {
        this.loadCustomFieldOptions(this.match)
    }

    public get match() {
        return this.card.match
    }

    public get context(): ContextualData | undefined {
        const { sectionIndex, cardIndex } = this.cardIndex
        return this.getContextual[`${sectionIndex}/${cardIndex}`]
    }

    public get errors() {
        return this.context && this.context.errors || {}
    }

    public get scope() {
        return this.context ? this.context.scope : {}
    }

    public get tabs() {
        return this.card.cases
    }

    public get canRemove() {
        // for scorecard, logic is fixed and can't change
        return this.card.cases.length > 1 && (!isScorecardCard(this.card) || !this.card.scorecardId)
    }

    public get options() {
        const { scope, card } = this
        const keys = scope[card.match]
        return [
            'default',
            ...(keys instanceof Array ? keys : [])
        ]
        .filter((key) => key)
    }

    // @todo selection must always have a default value unless there is a case for every option
    public get optionsRemaining() {
        const cases = this.card.cases as CardCases<BaseCard>
        return this.options.filter((key) =>
            !cases.find((c) => c.key === key || (typeof key === 'object' && c.key === key.key))
        )
    }

    public getTabDisplayName(tab) {
        let tabObj = this.options.find((opt) => (typeof opt === 'object' && opt.key === tab.key))
        if(typeof tabObj === 'object') {
            return tabObj.value;
        }
        return tab.key
    }

    public addCase(caseKey: string) {
        const branched = this.card as BranchCard
        const cases = branched.cases as CardCases<BaseCard>
        const blank = blankCard(this.card.type)

        // When adding a new case, if it is a param card
        // use the first param you can find there
        let card
        if (isParamCard(blank)) {
            const existing = firstCase(branched)
            if (existing && isParamCard(existing.card)) {
                if (existing.card.type === 'list') {
                    card = { ...blank, param: existing.card.param, options: existing.card.options.slice() }
                } else {
                    card = { ...blank, param: existing.card.param }
                }
            } else {
                card = { ...blank, param: 'field' }
            }
        } else {
            card = blank
        }

        const nextCase: CardCase<BaseCard> = { key: caseKey, card }

        this.$emit('change', {
            ...this.card,
            cases: caseKey === 'default' ? [nextCase].concat(cases) : cases.concat([nextCase])
        })

        this.activeTab = caseKey
    }

    public removeCase(key: string) {

        if (!this.canRemove) {
            return
        }

        const cases = this.card.cases as CardCases<BaseCard>
        const deletedIndex = cases.findIndex((x) => x.key === key)
        const nextCases = cases.filter((c) => c.key !== key)
        const activeTabRemoved = key === String(this.activeTab)

        this.$emit('change', {
            ...this.card,
            cases: nextCases
        })

        if (activeTabRemoved) {
            const nextActive =
                nextCases[deletedIndex] ||
                nextCases[deletedIndex - 1] ||
                nextCases.find(({ key }) => key === 'default')
            if (nextActive) {
                this.activeTab = String(nextActive.key)
            }
        }
    }

    public isValidCase(name: string) {
        return this.options.indexOf(name) > -1
    }

    public setActiveTab(tabKey) {
        this.activeTab = tabKey
    }

    public scorecardTab(tab) {
        return tab.key && ['promoter', 'detractor', 'passive', 'default'].includes(tab.key) &&
            this.card.match === 'rating' && tab.key || ''
    }
}
